import React, { Fragment } from 'react';
import constants from '../../constants';

const Navigation = ({ links = [], contentLink = null, myPageUrl, myPageText }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;
    const websiteSelector = document.getElementById('websiteSelectorContainer');
    let websiteSelectorHTML = websiteSelector ? websiteSelector.innerHTML : "";
    websiteSelectorHTML = websiteSelectorHTML.split("websiteSelectorCheckbox").join("websiteSelectorCheckboxMobile");

    return (
        <Fragment>
            {!contentLink ? (
                <button aria-label="Menu" className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}></button>
            ) : (
                    <Fragment>
                        <a className={`navbar__link ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''}`}
                            href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLink.name }} >
                        </a>
                        {links.length > 0 &&
                            <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                        }
                    </Fragment>
                )}

            { links.length > 0 &&
                <div className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}></span>
                        ) : (
                                <Fragment>
                                    <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                                    <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                                </Fragment>
                            )}
                    </div>
                    <ul>
                        {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                            <li className="navbar__item" key={link.url + i}>
                                <Navigation links={link.links} contentLink={link} />
                            </li>
                        )}
                    </ul>
                    {!contentLink &&
                        <div className="hide-for-large">
                            {constants.navigationAlternativeLinks && constants.navigationAlternativeLinks.one !== null && constants.navigationAlternativeLinks.one.length > 0 &&
                                <ul className="navbar__links-one">
                                    {
                                        constants.navigationAlternativeLinks.one.map((item, index, array) => (
                                            <li className="navbar__item" key={'altOne' + index}><a className="navbar__link" href={item.href}>{item.text}</a></li>
                                        ))}
                                </ul>
                            }
                            {constants.navigationAlternativeLinks && constants.navigationAlternativeLinks.two !== null && constants.navigationAlternativeLinks.two.length > 0 &&
                                <ul className="navbar__links-one">
                                    {
                                        constants.navigationAlternativeLinks.two.map((item, index, array) => (
                                            <li className="navbar__item" key={'altTwo' + index}><a className="navbar__link" href={item.href}>{item.text}</a></li>

                                        ))}
                                </ul>
                            }
                            {myPageUrl && myPageText &&
                                <ul className="navbar__links-login">
                                    <li className="navbar__item"><a className="navbar__link" href={myPageUrl}>{myPageText}</a></li>
                                </ul>
                            }
                            <div dangerouslySetInnerHTML={{ __html: websiteSelectorHTML }}></div>
                        </div>
                    }
                </div>
            }

        </Fragment>
    )
}

export default Navigation;